// Libraries
import _ from 'lodash';

// Supermove
import {gql} from '@supermove/graphql';
import {OrganizationModel, UserModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

// Shared
import UserRole from '@shared/modules/User/enums/UserRole';

export type EditAccessType = 'EDIT' | 'VIEW_NON_ADMIN' | 'VIEW_BRANCH';

export const getEditAccess = withFragment(
  (viewer: UserModel, organization: OrganizationModel) => {
    if (organization.kind !== 'MAIN') {
      return 'VIEW_BRANCH';
    }

    const hasEditPermissions = _.includes(UserRole.ADMIN_ROLES_PLUS_SUPER, viewer.role);
    if (hasEditPermissions) {
      return 'EDIT';
    }

    return 'VIEW_NON_ADMIN';
  },
  gql`
    fragment getEditAccess_user on User {
      id
      role
    }
    fragment getEditAccess_organization on Organization {
      id
      kind
    }
  `,
);
